import React from "react";
import "./Footer.css";
import location from "../assests/img/location.png";
import opd from "../assests/img/opd.png";
import cc from "../assests/img/cc.png";
import phone from "../assests/img/phone.png";
import email from "../assests/img/email.png";
import flogo from "../assests/img/logo.png";
import VisitorCounter from "./VisitorCounter";


export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-col footer-brand">
          <div className="footer-brand-head" style={{border: "none"}}>
            <h3 className="footer-logo-text"><img src={flogo} alt="logo" style={{width: "52px", float: "left",}} /></h3>
            <p className="footer-tagline">M.K.C.G. Medical<br />College &amp; Hospital</p>
          </div>
          <p className="footer-desc">
            Premier medical institution of Southern Odisha, established in 1962.
            Under the Department of Health & Family Welfare, Govt. of Odisha.
          </p>
       <p className="footer-emergency-label">Emergency Numbers</p>
      
            <p className="ft contact-row"><img src={opd} alt="opd" /> OPD: <a href="tel:06802290137">0680-2290137</a></p>
            <p className="ft contact-row"><img src={cc} alt="cc" />  Casualty: <a href="tel:06802290851">0680-2290851</a></p>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-links">
            {["About Us", "Departments", "Academic", "Staff", "Admissions", "Results", "Tenders"].map(l => (
              <li key={l}><a href="#">{l}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">Important</h4>
          <ul className="footer-links">
            {["Anti-Ragging", "RTI", "Citizen Charter", "NMC MARB Data", "Govt. Approval", "Photo Gallery", "Site Map"].map(l => (
              <li key={l}><a href="#">{l}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer-col">
          <h4 className="footer-heading">Contact Us</h4>
          <address className="footer-address">
            <p><img src={location} alt="location" /> Dean and Principal, M.K.C.G Medical College, Berhampur, Ganjam, Odisha – 760 004</p>
            <p className="contact-row"><img src={phone} alt="phone" /><a href="tel:06802292746">(0680) 2292746</a></p>
            <p className="contact-row"><img src={phone} alt="phone" /> (0680) 2292809</p>
            <p className="contact-row"><img src={email} alt="email" /><a href="mailto:principal.mkcgmc@gov.in">principal.mkcgmc@gov.in</a></p>
           
          </address>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© {new Date().getFullYear()} M.K.C.G. Medical College & Hospital, Berhampur. All rights reserved.</p>
          <VisitorCounter />
          <p className="anti-ragging">
            Designed by Orisys Infotech
          </p>
        </div>
      </div>
    </footer>
  );
}